import {Injectable} from '@angular/core';
import {EnvironmentService} from './environment-service';

@Injectable({
  providedIn: 'root'
})
export class DynamicScriptInjectionService {

  constructor(private environmentService: EnvironmentService) {
  }

  injectScript() {
    if (!this.environmentService.showJiraWidget()) {
      return;
    }
    this.loadJiraWidget()
      .then((_: void) => {
        // Do Nothing
      })
      .catch((error) => {
        console.error('Error: ', error);
      });
  }

  private loadJiraWidget(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const jiraWidgetScript: HTMLScriptElement = document.createElement('script');
      jiraWidgetScript.src = 'https://jsd-widget.atlassian.com/assets/embed.js';
      jiraWidgetScript.onload = () => {
        const widgetDataKey: string = this.environmentService.getJiraWidgetDataKey();
        jiraWidgetScript.setAttribute('data-jsd-embedded', '');
        jiraWidgetScript.setAttribute('data-key', widgetDataKey);
        jiraWidgetScript.setAttribute('data-base-url', 'https://jsd-widget.atlassian.com');
        resolve();
      };
      jiraWidgetScript.onerror = (error) => {
        reject(error);
      };
      jiraWidgetScript.addEventListener('load', (event: Event) => {
          window.document.dispatchEvent(new Event('DOMContentLoaded', {
            bubbles: true,
            cancelable: true
          }));
        }
      );
      document.body.appendChild(jiraWidgetScript);
    });
  }
}
